import { useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";
import { isAuthenticated } from "@/store";
import {
  pendingRequestQueue,
  performSilentRefresh,
} from "@/services/axiosInterceptor";
import { emitTokenRefreshed } from "@/services/sessionEvents";

const REFRESH_INTERVAL_MS = 50 * 60 * 1000;

const AuthSessionRefresher = () => {
  const userAuthenticated = useRecoilValue(isAuthenticated);
  const intervalRef = useRef(null);
  const refreshInFlightRef = useRef(false);

  useEffect(() => {
    if (!userAuthenticated) return undefined;

    const refreshTokens = async () => {
      if (refreshInFlightRef.current) return;

      refreshInFlightRef.current = true;
      try {
        const newToken = await performSilentRefresh();
        emitTokenRefreshed({ at: Date.now() });
        pendingRequestQueue.flush(newToken);
      } catch (error) {
        console.warn("[AuthSessionRefresher] Token refresh failed:", error);
      } finally {
        refreshInFlightRef.current = false;
      }
    };

    intervalRef.current = window.setInterval(
      refreshTokens,
      REFRESH_INTERVAL_MS,
    );

    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [userAuthenticated]);

  return null;
};

export default AuthSessionRefresher;
